import { RADIUSVALUES } from '../../../shared/constants';

export const getConfigurationsBasedOnLocations = ({ searchLocations }) => {
  const [firstLocation] = searchLocations || [];
  if (firstLocation) {
    const isMultipleLocations = searchLocations.length > 1;
    const { level } = firstLocation;
    if (level === 6) {
      return {
        locationsText: 'della provincia selezionata',
        radiusValues: RADIUSVALUES.large,
      };
    }
    if (level === 9) {
      return {
        locationsText: `de${isMultipleLocations ? 'i' : 'l'} comun${isMultipleLocations ? 'i' : 'e'} selezionat${isMultipleLocations ? 'i' : 'o'}`,
        radiusValues: RADIUSVALUES.large,
      };
    }
    if (level > 9) {
      return {
        locationsText: `de${isMultipleLocations ? 'lle' : 'lla'} zon${isMultipleLocations ? 'e' : 'a'} selezionat${isMultipleLocations ? 'e' : 'a'}`,
        radiusValues: RADIUSVALUES.small,
      };
    }
  }
  return {
    locationsText: 'della località selezionata',
    radiusValues: RADIUSVALUES.large,
  };
};
